function convertJSONToCSV(jsonData, columnHeaders) {
    if (columnHeaders.length == 0) return '';
    if (jsonData.length == 0) return '';
    let csvString = columnHeaders.join(',') + '\n';
    jsonData.forEach(row => {
        const values = columnHeaders.map(header => {
          const value = row[header];
          return typeof value === 'string' && value.includes(',') ? `"${value}"` : value;
        });
        csvString += values.join(',') + '\n';
    });
    return csvString;
}

const downloadCSV = (data, filename) => {
  const blob = new Blob([data], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
};

function getFilteredTableData(filterTable) {
    const tableData = [];
    const data = Object.values(filterTable).map(row => {
      const rowObj = {};
      row.getVisibleCells().map(cell => {
        rowObj[cell.column.id] = cell.getValue();
      });
      tableData.push(rowObj);
    });
    return tableData;
}

export const MatrixExportAll = (data) => {
  const jsonData = data.map(item => { 
    const copy = { ...item };
    delete copy.ID;
    delete copy.EntityID;
    return copy;
  });
  const columnHeaders = Object.keys(jsonData[0] || {});
  const csvData = convertJSONToCSV(jsonData, columnHeaders);
  downloadCSV(csvData, 'matrix_data.csv');
};

export const MatrixExport = (rows, pagination) => {
  const start = pagination.pageIndex * pagination.pageSize;
  const jsonData = getFilteredTableData(rows.slice(start, start + pagination.pageSize));
  const columnHeaders = Object.keys(jsonData[0] || {});
  const csvData = convertJSONToCSV(jsonData, columnHeaders);
  downloadCSV(csvData, 'matrix_data.csv');
};



